import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = {
  key: 0,
  class: "nav-btn"
}
const _hoisted_3 = { class: "preview-cards" }
const _hoisted_4 = { class: "side-card-wrapper left" }
const _hoisted_5 = { class: "side-card-wrapper right" }
const _hoisted_6 = {
  key: 1,
  class: "dots"
}
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_project_preview = _resolveComponent("project-preview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollAvant && _ctx.scrollAvant(...args))),
            class: "mdi mdi-menu-up btn"
          }),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollApres && _ctx.scrollApres(...args))),
            class: "mdi mdi-menu-down btn"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_project_preview, {
          onClick: _ctx.scrollAvant,
          model: _ctx.precedent,
          class: "back-cards"
        }, null, 8, ["onClick", "model"])
      ]),
      _createVNode(_component_project_preview, {
        model: _ctx.courant,
        "can-redirect": true,
        class: "front-card"
      }, null, 8, ["model"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_project_preview, {
          onClick: _ctx.scrollApres,
          model: _ctx.suivant,
          class: "back-cards"
        }, null, 8, ["onClick", "model"])
      ])
    ]),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, dotIndex) => {
            return (_openBlock(), _createElementBlock("span", {
              key: dotIndex,
              class: _normalizeClass(_ctx.getDotClass(dotIndex)),
              onClick: ($event: any) => (_ctx.scrollToIndex(dotIndex))
            }, null, 10, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}